import type { GridSortModel } from "@mui/x-data-grid-pro"

export const mapSortModelToParams = (
  sortModel: GridSortModel,
  fieldMap: Record<string, string>
): { sort_by: string[] | undefined; sort_direction: string[] | undefined } => {
  const sort_by: string[] = []
  const sort_direction: string[] = []

  for (const item of sortModel) {
    const apiField = fieldMap[item.field]
    if (apiField && item.sort) {
      sort_by.push(apiField)
      sort_direction.push(item.sort)
    }
  }

  return sort_by.length
    ? { sort_by, sort_direction }
    : { sort_by: undefined, sort_direction: undefined }
}
